import { getMegaraxPath, PriceListTab } from "@megaron/megarax-uri";

export const PRICE_LIST_HOME = getMegaraxPath.uri("megarax://crm/price-lists");
export const PRICE_LIST_NEW = getMegaraxPath.uri("megarax://crm/price-lists/new");

const priceListTabPath = (uuid: string, tab: PriceListTab) =>
  getMegaraxPath.uri("megarax://crm/price-list-tabs/id/{id}/{tab}", { id: uuid, tab });

export const PRICE_LIST_DETAILS = priceListTabPath(":uuid", "current").split("/").slice(0, -1).join("/");

export const PROPOSAL_DETAILS = `${PRICE_LIST_DETAILS}/proposals/proposal/:proposalUuid`;
export const PROPOSAL_NEW = `${PRICE_LIST_DETAILS}/:tab/proposal`;

export const CURRENT_DETAILS = `${PRICE_LIST_DETAILS}/current/trade-item/:gtin`;
export const PROPOSE_CHANGE = `${CURRENT_DETAILS}/propose-change`;
export const PROPOSE_DELETION = `${CURRENT_DETAILS}/propose-deletion`;

export const getPriceListHomeUrl = () => PRICE_LIST_HOME;
export const getPriceListDetailsUrl = (uuid: string) => priceListTabPath(uuid, "current");
export const getPriceListNewUrl = () => PRICE_LIST_NEW;

export const getCurrentDetailsUrl = (uuid: string) => (gtin: string) =>
  `${getPriceListDetailsUrl(uuid)}/trade-item/${gtin}`;
export const getProposeDeletionUrl = (uuid: string, gtin: string) =>
  `${getCurrentDetailsUrl(uuid)(gtin)}/propose-deletion`;
export const getProposeEditUrl = (uuid: string, gtin: string) => `${getCurrentDetailsUrl(uuid)(gtin)}/propose-change`;

export const getNewProposalUrl = (uuid: string, tab: PriceListTab) => `${priceListTabPath(uuid, tab)}/proposal`;
export const getProposalDetailUrl = (uuid: string, proposalUuid: string) =>
  `${priceListTabPath(uuid, "proposals")}/proposal/${proposalUuid}`;
